module.exports = __webpack_public_path__ + "img/feixinjiaju9.434435e0.jpg";